import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../shared/services/user.service';
import { User } from '../../../../shared/models/User';
import { AuthService } from '../../../../shared/services/auth.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  user: User;

  showB2ALogo: boolean = false;
  isLoggedIn: boolean = false;

  backend: string = '';
  public timestamp = 0;

  constructor(private userService: UserService, private auth: AuthService) {
    userService.currentUser.subscribe((user) => {
      if (!user) { return; }

      this.user = user;
      this.showB2ALogo = false;
    });

    this.backend = environment.backendUrl;
    this.timestamp = Date.now();
    auth.loggedIn.subscribe((value) => (this.isLoggedIn = value));
  }
  ngOnInit() {}
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/header/components/logo/logo.component.ts